import { FC } from 'react';
import { useSelector } from 'react-redux';
import { useShowSearchMetaTooltip } from 'shared/hooks';
import { useBedsChangeHandler } from './hooks';
import { selectBedsFilter } from 'shared/selectors/filters';
import { DropdownBeds, DropdownFilter, useDropdown } from 'shared/components/DropdownFilter';
import { FILTER_KEY } from './constants';
import { selectIsInlineFiltersRedesigned } from 'shared/selectors/redesigned/selectIsInlineFiltersRedesigned';

export const BedsContainer: FC = () => {
  const { label, value, max, min } = useSelector(selectBedsFilter);

  const onChange = useBedsChangeHandler();

  const dropdownState = useDropdown(FILTER_KEY);

  const showTooltip = useShowSearchMetaTooltip(FILTER_KEY);

  const isFiltersRedesignEnabled = useSelector(selectIsInlineFiltersRedesigned);

  return (
    <DropdownFilter
      {...dropdownState}
      showTooltip={showTooltip}
      buttonLabel={label}
      isFiltersRedesignEnabled={isFiltersRedesignEnabled}
      dropdownContent={<DropdownBeds value={value} max={max} min={min} onChange={onChange} />}
    />
  );
};
